import { View } from "@react-pdf/renderer";
import { CellTextBoxDot, narrowCellsFrench, styles } from "../reportingHelpers";
import React from "react";

export const BoxscoreTableHeader = ({ intl, team, roles }) => (
  <View
    style={{
      ...styles.tableRow,
      borderRightWidth: 0,
      backgroundColor: "white",
    }}
  >
    <View
      style={{
        ...styles.tableHeaderColumnFrench,
        flexDirection: "column",
      }}
    >
      <CellTextBoxDot
        style={{
          width: "36.8mm",
          fontFamily: ["Noto Sans", "Noto Sans TC"],
          fontWeight: "bold",
          textAlign: "left",
          paddingLeft: 2,
        }}
      >
        {team.team.name}
      </CellTextBoxDot>
      <CellTextBoxDot
        style={{
          width: "36.8mm",
          fontFamily: ["Noto Sans", "Noto Sans TC"],
          fontWeight: "normal",
          textAlign: "left",
          paddingLeft: 2,
        }}
      >
        {intl.formatMessage({
          id: "reports.scoresheet.table.coach",
          defaultMessage: "Coach",
        })}
        :{" "}
        {roles.find(
          (role) =>
            role.entityId === team.team.entityId && role.role === "COACH"
        )?.name ?? ""}
      </CellTextBoxDot>
    </View>
    <CellTextBoxDot
      style={{
        ...styles.tableHeaderColumnFrench,
        ...styles.tableHeaderColumnFrench,
        width: "4mm",
      }}
    >
      {intl.formatMessage({
        id: "reports.frenchboxscore.table.starting5",
        defaultMessage: "Starting 5",
      })}
    </CellTextBoxDot>
    <CellTextBoxDot style={{ ...styles.tableHeaderColumnFrench, width: "9mm" }}>
      {intl.formatMessage({
        id: "reports.boxscore.table.min",
        defaultMessage: "Min",
      })}
    </CellTextBoxDot>
    <CellTextBoxDot
      style={{
        ...styles.tableHeaderColumnFrench,
        ...styles.tableHeaderCellFrench,
        width: "6mm",
      }}
    >
      {intl.formatMessage({
        id: "reports.boxscore.table.pts",
        defaultMessage: "PTS",
      })}
    </CellTextBoxDot>

    <View style={{ ...styles.tableHeaderGroup }}>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "16mm",
            ...styles.tableHeaderCellFrench,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.fieldgoals",
            defaultMessage: "Field goals",
          })}
        </CellTextBoxDot>
      </View>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "8mm",
            fontWeight: "normal",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madeattempts",
            defaultMessage: "M/A",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot style={{ width: "8mm", fontWeight: "normal" }}>
          {intl.formatMessage({
            id: "reports.boxscore.table.madepercent",
            defaultMessage: "%",
          })}
        </CellTextBoxDot>
      </View>
    </View>

    <View style={{ ...styles.tableHeaderGroup }}>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "16mm",
            ...styles.tableHeaderCellFrench,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.threepoints",
            defaultMessage: "3 Points",
          })}
        </CellTextBoxDot>
      </View>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            ...styles.tableHeaderCellFrench,
            width: "8mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madeattempts",
            defaultMessage: "M/A",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ ...styles.tableHeaderCellFrench, width: "8mm" }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madepercent",
            defaultMessage: "%",
          })}
        </CellTextBoxDot>
      </View>
    </View>

    <View style={{ ...styles.tableHeaderGroup }}>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "16mm",
            ...styles.tableHeaderCellFrench,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.twopointsoutside",
            defaultMessage: "2 Points Outside",
          })}
        </CellTextBoxDot>
      </View>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            ...styles.tableHeaderCellFrench,
            width: "8mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madeattempts",
            defaultMessage: "M/A",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ ...styles.tableHeaderCellFrench, width: "8mm" }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madepercent",
            defaultMessage: "%",
          })}
        </CellTextBoxDot>
      </View>
    </View>

    <View style={{ ...styles.tableHeaderGroup }}>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "16mm",
            ...styles.tableHeaderCellFrench,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.twopointsinside",
            defaultMessage: "2 Points Inside",
          })}
        </CellTextBoxDot>
      </View>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            ...styles.tableHeaderCellFrench,
            width: "8mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madeattempts",
            defaultMessage: "M/A",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ ...styles.tableHeaderCellFrench, width: "8mm" }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madepercent",
            defaultMessage: "%",
          })}
        </CellTextBoxDot>
      </View>
    </View>

    <CellTextBoxDot style={{ ...styles.tableHeaderColumnFrench, width: "6mm" }}>
      {intl.formatMessage({
        id: "reports.boxscore.table.dunks",
        defaultMessage: "Dunks",
      })}
    </CellTextBoxDot>

    <View style={{ ...styles.tableHeaderGroup }}>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "16mm",
            ...styles.tableHeaderCellFrench,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.ft",
            defaultMessage: "Free throws",
          })}
        </CellTextBoxDot>
      </View>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            ...styles.tableHeaderCellFrench,
            width: "8mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madeattempts",
            defaultMessage: "M/A",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ ...styles.tableHeaderCellFrench, width: "8mm" }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.madepercent",
            defaultMessage: "%",
          })}
        </CellTextBoxDot>
      </View>
    </View>

    <View style={{ ...styles.tableHeaderGroup }}>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "12mm",
            ...styles.tableHeaderCellFrench,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.fouls",
            defaultMessage: "Fouls",
          })}
        </CellTextBoxDot>
      </View>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            ...narrowCellsFrench,
            ...styles.tableHeaderCellFrench,
            width: "6mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.foulspf",
            defaultMessage: "PF",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{
            ...narrowCellsFrench,
            ...styles.tableHeaderCellFrench,
            width: "6mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.foulsfd",
            defaultMessage: "FD",
          })}
        </CellTextBoxDot>
      </View>
    </View>

    <View style={{ ...styles.tableHeaderGroup }}>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "12mm",
            ...styles.tableHeaderCellFrench,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.bsdesc",
            defaultMessage: "Blocked Shots",
          })}
        </CellTextBoxDot>
      </View>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            ...narrowCellsFrench,
            ...styles.tableHeaderCellFrench,
            width: "6mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.bf",
            defaultMessage: "BF",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{
            ...narrowCellsFrench,
            ...styles.tableHeaderCellFrench,
            width: "6mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.ba",
            defaultMessage: "BA",
          })}
        </CellTextBoxDot>
      </View>
    </View>

    <View style={{ ...styles.tableHeaderGroup }}>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            width: "18mm",
            ...styles.tableHeaderCellFrench,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.rebounds",
            defaultMessage: "Rebounds",
          })}
        </CellTextBoxDot>
      </View>
      <View style={{ ...styles.tableHeaderGroupRow }}>
        <CellTextBoxDot
          style={{
            ...narrowCellsFrench,
            ...styles.tableHeaderCellFrench,
            width: "6mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.reboundsor",
            defaultMessage: "OR",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{
            ...narrowCellsFrench,
            ...styles.tableHeaderCellFrench,
            width: "6mm",
            borderRightColor: "white",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.reboundsdr",
            defaultMessage: "DR",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{
            ...narrowCellsFrench,
            ...styles.tableHeaderCellFrench,
            width: "6mm",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.reboundstotal",
            defaultMessage: "Tot",
          })}
        </CellTextBoxDot>
      </View>
    </View>

    <CellTextBoxDot
      style={{
        ...styles.tableHeaderColumnFrench,
        ...narrowCellsFrench,
        ...styles.tableHeaderCellFrench,
        borderBottomColor: "white",
        width: "6mm",
        borderRightColor: "white",
      }}
    >
      {intl.formatMessage({
        id: "reports.boxscore.table.st",
        defaultMessage: "ST",
      })}
    </CellTextBoxDot>
    <CellTextBoxDot
      style={{
        ...styles.tableHeaderColumnFrench,
        ...narrowCellsFrench,
        ...styles.tableHeaderCellFrench,
        width: "6mm",
      }}
    >
      {intl.formatMessage({
        id: "reports.boxscore.table.to",
        defaultMessage: "TO",
      })}
    </CellTextBoxDot>
    <CellTextBoxDot
      style={{
        ...styles.tableHeaderColumnFrench,
        ...narrowCellsFrench,
        ...styles.tableHeaderCellFrench,
        width: "6mm",
      }}
    >
      {intl.formatMessage({
        id: "reports.boxscore.table.as",
        defaultMessage: "AS",
      })}
    </CellTextBoxDot>

    <CellTextBoxDot
      style={{
        ...styles.tableHeaderColumnFrench,
        ...narrowCellsFrench,
        ...styles.tableHeaderCellFrench,
        width: "7mm",
      }}
    >
      {intl.formatMessage({
        id: "reports.boxscore.table.ef",
        defaultMessage: "EF",
      })}
    </CellTextBoxDot>
    <CellTextBoxDot
      style={{
        ...styles.tableHeaderColumnFrench,
        ...narrowCellsFrench,
        ...styles.tableHeaderCellFrench,
        borderRightWidth: 1,
      }}
    >
      {intl.formatMessage({
        id: "reports.boxscore.table.plusminus",
        defaultMessage: "+/-",
      })}
    </CellTextBoxDot>
  </View>
);
